const $$splitComponentImporter = () => import('/build/web/src/routes/_authenticated/chat-records/sessions/$session_key.turns.$turn_id.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
/*
Copyright (C) 2023-2026 QuantumNous

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

For commercial licensing, please contact support@quantumnous.com
*/
// Turn-view revamp v4 (任务 5 — 2026-05-23) — L3 route.
// `/chat-records/sessions/:session_key/turns/:turn_id` shows the per-call
// drill-down inside one human-turn.  L1 → L2 → L3 is the canonical chat-
// record navigation path; the legacy `/chat-records/records/:request_id`
// route remains for shareable deep links (see deprecation note there).
import { createFileRoute, redirect } from '@tanstack/react-router';
import { useAuthStore } from '@/stores/auth-store';
import { ROLE } from '@/lib/roles';
export const Route = createFileRoute('/_authenticated/chat-records/sessions/$session_key/turns/$turn_id')({
  beforeLoad: () => {
    const auth = useAuthStore.getState().auth;
    if (!auth.user || auth.user.role < ROLE.ADMIN) {
      throw redirect({
        to: '/403'
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});